'use client';

import React__default, { useState, useRef } from 'react';
import S from './SelectedTag.module.css.js';
import { IconDeleteWhite, IconCheck, IconAdd } from '../icons/index.js';

/* eslint-disable no-unused-expressions */
var SelectedTag = function (props) {
    var _a = props.tagName, tagName = _a === void 0 ? '' : _a, _b = props.isSelecting, isSelecting = _b === void 0 ? false : _b, _c = props.hasApproved, hasApproved = _c === void 0 ? true : _c, _d = props.readOnly, readOnly = _d === void 0 ? false : _d, _e = props.type, type = _e === void 0 ? 'default' : _e, _f = props.onClick, onClick = _f === void 0 ? function () { } : _f, _g = props.onDelete, onDelete = _g === void 0 ? function () { } : _g;
    var _h = useState(false), isHovered = _h[0], setIsHovered = _h[1];
    var deleteIconRef = useRef(null);
    // normal status
    var styleSelected = "".concat(S.NormalStatus);
    // normal status with hover or is selecting
    if ((hasApproved && isHovered && !readOnly) || (hasApproved && isSelecting)) {
        styleSelected = "".concat(styleSelected, " ").concat(S.NormalStatusHover);
    }
    // reviewing status
    if (!hasApproved && !readOnly) {
        styleSelected = "".concat(styleSelected, " ").concat(S.ReviewingStatus);
    }
    // reviewing status with hover or is selecting
    if ((!hasApproved && isHovered && !readOnly) || (!hasApproved && isSelecting)) {
        styleSelected = "".concat(styleSelected, " ").concat(S.ReviewingStatusHover);
    }
    // ReadOnly status
    if (readOnly) {
        styleSelected = "".concat(styleSelected, " ").concat(S.DeletedTag);
    }
    var styledCheckIcon = isSelecting ? '#fff' : '#888';
    if (!hasApproved && !readOnly && !isSelecting) {
        styledCheckIcon = '#FF7D55';
    }
    var handleClickOnTag = function (e) {
        if (deleteIconRef.current) {
            if (deleteIconRef.current.contains(e.target)) {
                e.stopPropagation();
                onDelete(tagName);
                return;
            }
        }
        onClick();
    };
    var isMobile = !!(typeof window !== 'undefined' && window.innerWidth < 992);
    return (React__default.createElement("div", { className: styleSelected, onClick: function (e) {
            if (!readOnly) {
                handleClickOnTag(e);
            }
        }, onMouseEnter: function () { return (!isMobile ? setIsHovered(true) : undefined); }, onMouseLeave: function () { return (!isMobile ? setIsHovered(false) : undefined); } },
        React__default.createElement("div", null, tagName),
        React__default.createElement("div", { ref: deleteIconRef, className: S.wrapIcon }, (isHovered && !isMobile && !readOnly && type !== 'add') || // desktop
            (isMobile && isSelecting && !readOnly && type !== 'add') ? ( // mobile
        React__default.createElement(IconDeleteWhite, { stroke: '#fff', width: 22, height: 22, className: S.IconDelete, onClick: handleClickOnTag })) : type !== 'add' ? (React__default.createElement(IconCheck, { stroke: styledCheckIcon, width: 22, height: 22 })) : null),
        type === 'add' ? React__default.createElement(IconAdd, { fill: isHovered ? '#fff' : '#777' }) : null));
};

export { SelectedTag as default };
//# sourceMappingURL=index.js.map
